// extracted by mini-css-extract-plugin
export var dividerLine = "_6i-3";
export var itemImage = "_6i-9";
export var lightDivider = "_6i-4";
export var modalContent = "_6i-5";
export var modalContentCompact = "_6i-6";
export var productCard = "_6i-a";
export var productImage = "_6i-b";
export var productImageCompact = "_6i-7";
export var productImagePlaceholder = "_6i-c";
export var productImagePlaceholderCompact = "_6i-8";
export var progressBarBackground = "_6i-1";
export var progressBarContainer = "_6i-0";
export var progressBarFill = "_6i-2";